<template>
  <div class="showpush">
    <!-- <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt="">
        <el-breadcrumb separator="/">

          <el-breadcrumb-item>创建推送</el-breadcrumb-item>

        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img width="16px" height="16px" src="@/assets/house/refresh.png" alt="">
        <p>刷新</p>
      </div>
    </div> -->

    <div class="main">
      <div class="head">
        <h4>推送至：{{$route.query.name}}</h4>
      </div>
      <div class="tablebg">
        <div style="width:calc(100% - 300px);margin:0 auto;padding:20px;">
          <showpushform @closeForm="closeForm"
                        @submitForm="submitForm"></showpushform>

          <!-- <el-button @click="dialogFormVisible = true">弹框表单</el-button> -->
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { showpushform } from '@/components/index'
import { addPicturePackage } from "@/api/picturePackage";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    'showpushform': showpushform
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      
    };
  },
  methods: {
    ...mapActions(["setLoveList"]),

    closeForm () {
      this.$router.push('/desktop/contributor')
    },

    submitForm (val, choosePic) {
      let images = []
      for (let j = 0; j < choosePic.length; j++) {
        let imgInfo = {
          fid: '',
          path: ''
        }
        imgInfo.fid = choosePic[j].id
        imgInfo.path = choosePic[j].src
        images.push(imgInfo)
      }

      let pushConfig = {
        pushChannelId: this.$route.query.pushChannelId,
        author: val.author,
        source: val.source,
        files: images,
        content: val.content
      }

      let choosePicMsg = {
        createUid: this.createUid,
        packageType: "push",
        pictureCount: choosePic.length,
        pictureIds: '',
        title: val.title,
        pushConfig: JSON.stringify(pushConfig)
      }

      for (let i = 0; i < choosePic.length; i++) {
        if (i === choosePic.length - 1) {
          choosePicMsg.pictureIds += choosePic[i].id
        } else {
          choosePicMsg.pictureIds += choosePic[i].id + ','
        }
      }

      this.addPicturePackageAsync(choosePicMsg)
      if (!this.$route.query.isSavePic) {
        let loveList = []
        this.setLoveList(this.loveList)
        sessionStorage.removeItem("picLove");
      }
      setTimeout(() => {
        this.$router.push('/shareAndPush/myPush')
          }, 1500);
    },



    //增加图片包

    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("添加成功！");

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


  },
  created () {

  },
  mounted () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./showpush.scss";

h4 {
  font-size: 18px;
}
</style>
